import styled from 'styled-components';

export const Icon = styled.div`
  position: absolute;
  top: 38%;
  left: 50%;
  width: 40%;
  height: 40%;
  margin-top: calc(-40% / 2);
  margin-left: calc(-40% / 2);
  color: white;
`;
